export default __webpack_public_path__ + "static/media/B52_13.9cb745f1.webp";